import React from 'react';

function EmailIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14">
      <path d="M1.14.41A1.15,1.15,0,0,0,0,1.55v10.9a1.15,1.15,0,0,0,1.14,1.14H18.86A1.15,1.15,0,0,0,20,12.45V1.55A1.15,1.15,0,0,0,18.86.41Zm1.3,1.36H17.56L10.24,8.31a.46.46,0,0,1-.48,0Zm-1.08.86L6.47,7.2,1.36,11.42Zm17.28,0v8.79L13.53,7.2ZM7.5,8.12l1.35,1.2a1.72,1.72,0,0,0,2.3,0l1.35-1.2,5,4.11H2.53l5-4.11Z" />
    </svg>
  );
}

export default EmailIcon;
